@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row) {
    <span>{{ getPaymentDetailsReport($.row) }} </span>
  }
}
